/* eslint-disable */
import { IReportDefinitionsService, ReportDefinition, ComponentType, MultiplicityType } from "@sa/rep-core";
import { MDDEResult, MDDEQuery, IMDDEService } from "@sa/rep-mdde";
import { DataType } from "@sa/rep-common";
import { CubeDefinition, IOLAPMetadataApiService } from "@sa/rep-olap";
import { getJSON, post } from "../../../http"; 
import { ReportDefinitionBasf } from "../types/ReportDefinitionBasf";


export interface IReportServiceConfig {
  baseUrl: string;
}

export class ReportService implements IReportDefinitionsService {
  //IOLAPMetaReportApiService {
  protected _baseUrl: string;

  constructor(config: IReportServiceConfig) {
    this._baseUrl = config.baseUrl;
  }

  async getDefinition(id: string): Promise<ReportDefinitionBasf> {
    if (id === "example") {
      const def: ReportDefinitionBasf = {
        id: "example",
        components: [
          {
            id: "EXMPL",
            type: ComponentType.Custom,
            options: {},
          },
        ],
        layouts: {},
        names: {},
        parameters: [
          {
            id: "Parameter1",
            allowNullable: false,
            multiplicityType: MultiplicityType.Single,
            type: DataType.Number,
            value: 1,
          },
        ],
        sourcesTemplates: [],
        sources: "Example sources"
      };
      return Promise.resolve(def);
    }
    const model = await getJSON<ReportDefinitionBasf>(`${this._baseUrl}/reports/${id}/model`);
    return model;
  }
}
